
import { CommonService } from "@/api/common";
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { computed, defineComponent, reactive, toRefs, ref } from "vue";

export default defineComponent({
  name: "SearchBanner",
  components: {},
  setup() {
    const store = useStore();
    const search = computed(() => store.state.seachKey);
    const searchKey = reactive({
      keyValue: search.value,
    });

    const historyList = computed(() => store.state.searchHistoryList);
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    const onKey = (name: string) => {
      searchKey.keyValue = name;
      onSearch();
    };
    const searchList = ref([]);
    const getSearchTags = async () => {
      const params = {};
      const res = await CommonService.getSearchTags(params);
      if (res.data.state === 2) {
        searchList.value = res.data.data;
      }
    };
    getSearchTags();
    return {
      ...toRefs(searchKey),
      onSearch,
      historyList,
      searchList,
      onKey,
    };
  },
});
